import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import SearchLink from "./SearchLink";

const RowDetailField = (props) => (
  <Grid
    className={props.className}
    display={props.display}
    container
    spacing={1}
    xs={12}
    sm={props.pre ? 12 : 6}
    md={props.pre ? 12 : 4}
    lg={props.pre ? 12 : 3}
  >
    <Grid
      xs={5}
      sm={props.pre ? 2.5 : 5}
      md={props.pre ? 1.65 : 5}
      lg={props.pre ? 1.25 : 5}
      className="fieldLabel"
    >
      {props.label}:
    </Grid>
    <Grid xs={7} title={props.title}>
      {props.href ? (
        <SearchLink href={props.href}>{props.value}</SearchLink>
      ) : props.pre ? (
        <div className="pre">{props.value}</div>
      ) : (
        props.value
      )}
    </Grid>
  </Grid>
);

export default styled(RowDetailField)(
  ({ theme }) => `
  .fieldLabel {
    font-family: milliard-medium;
    font-weight: 700;
    text-align: right;
  }

  .pre {
    white-space: pre-wrap;
  }
`,
);
